<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-07-27 14:35:49
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-07 10:32:51
 * @FilePath: \mrc-base-frontend\src\views\userAccount\index.vue
--> 
<template>
  <v-container>
    <v-card>
      <v-card-text>
        <button @click="menu">upd-menu</button><br />
        <button @click="user">upd-user</button><br />
        <button>upd-menu-user</button>
        <h3 class="mb-5">账户</h3>
        <div
          style="border: 1px solid #dedede; border-radius: 5px"
          class="d-flex align-center justify-center"
        >
          <div
            class="img pa-2"
            style="position: relative; top: -20px; right: 30px"
          >
            <v-img
              style="width: 150px; height: 150px; border-radius: 50%"
              src="https://picsum.photos/500/300?image=25"
              class="grey lighten-2"
            >
            </v-img>
          </div>
          <div
            class="d-flex flex-column py-2"
            style="width: 42%; max-width: 1000px"
          >
            <mrc_ess_input
              v-model.trim="user_account"
              class="my-2"
              :label="$t('label_account')"
              :rules="$text_rules($t('label.required'))"
            >
            </mrc_ess_input>
            <mrc_ess_input
              :label="$t('label.login_password')"
              v-model.trim="user_pwd"
              class="my-2"
              :type="type"
              :append-icon="icon"
              :rules="$text_rules($t('label.required'))"
              @click:append="showPassword"
            >
            </mrc_ess_input>
            <div class="my-4" style="color: #a2a2a2">上次更新：2018年</div>
            <v-btn
              rounded
              class="my-4"
              color="#fff"
              style="
                border: 1px solid #ececec;
                min-width: 135px;
                max-width: 200px;
                color: #a2a2a2;
              "
              :elevation="0"
              >登出</v-btn
            >
          </div>
          <v-btn
            text
            class="mb-7 ml-4"
            color="primary"
            style="text-decoration: underline"
          >
            {{ $t("label_To_reset_your_password") }}
          </v-btn>
        </div>
        <h3 class="mb-5 mt-5">{{ $t("label_language") }}</h3>
        <div
          style="border: 1px solid #dedede; border-radius: 5px"
          class="d-flex align-center justify-center py-4"
        >
          <!-- :disabled='disabled' -->
          <mrc_ess_prompt
            style="width: 42%; max-width: 1000px"
            :errMsg="$errors(null, 'language_uuid', requiredRule)"
            :rules="false"
            label="默认语言"
            obj="language_client"
            v-model="language_uuid"
          >
          </mrc_ess_prompt>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import http from "@/service/httpConfig.js";
import { required } from "vuelidate/lib/validators";
export default {
  components: {},
  props: {},
  data() {
    return {
      is_showPassword: false,
      icon: "mdi-eye-off",
      type: "password",
      user_account: "",
      user_pwd: "",
      language_uuid: "",
    };
  },
  validations: {
    language_uuid: {
      required,
    },
  },
  computed: {},
  created() {},
  watch: {},
  mounted() {},

  methods: {
    getLanguageAndUrl(arr) {
      arr.forEach((item) => {
        if (item.menus_tree && item.menus_tree.length > 0) {
          this.getLanguageAndUrl(item.menus_tree);
        } else {
          this.$store.commit("setAllMenuUrlList", {
            url: item.url,
            // title: item.language_name
            title: item.menu_name,
            function_uuid: item.function_uuid,
          });
        }
      });
    },
    async menu() {
      const res = await http.post("/api/menu/list-user-menus/v1", {
        product_shortcode: "MMS",
      });
      // http.post('/api/menu/list-user-menus/v1', {}).then(res => {
      //   let menuarr = res.data
      //   this.getLanguageAndUrl(menuarr)
      //   this.$store.commit('setCurrentCopmpanyMenu', [])
      //   console.log(menuarr);
      // })

      // this.$http.post('api/menu/list-user-menus/v1').then(res => { })
    },
    user() {
      http.post("/update-user-info/v1", {}).then((res) => {});
      // this.$http.post('update-user-info/v1').then(res => { })
    },
    upduser() {
      http
        .post("/api/menu/list-user-menus/v1", {
          product_shortcode: "MMS",
        })
        .then((res) => {});
      http.post("update-user-info/v1").then((res) => {});
    },
    showPassword() {
      this.is_showPassword = !this.is_showPassword;
      if (this.is_showPassword) {
        this.icon = "mdi-eye";
        this.type = "text";
      } else {
        this.icon = "mdi-eye-off";
        this.type = "password";
      }
    },
  },
};
</script>

<style scoped>
</style>
